<template>
  <div class="crud_form_wrapper single_show_content_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("SIDENAV.SecurityCompanies.show") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #26a1d6">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <!-- ==== Start:: Status Badge ==== -->
      <div class="badges_wrapper justify-content-end mb-3">
        <v-chip :color="data.active ? 'green' : 'red'" text-color="white">
          {{ data.active ? $t("STATUS.active") : $t("STATUS.notActive") }}
        </v-chip>
      </div>
      <!-- ==== End:: Status Badge ==== -->

      <!-- ==== Start:: Security Company Data ==== -->
      <form>
        <div class="row">
          <!-- Start:: Section Title -->
          <div class="col-12 mb-4">
            <h5
              style="
                color: #26a1d6;
                border-bottom: 2px solid #26a1d6;
                padding-bottom: 10px;
              "
            >
              {{ $t("SIDENAV.SecurityCompanies.companyData") }}
            </h5>
          </div>

          <!-- Start:: Company Name -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.SecurityCompanies.name')"
            v-model.trim="data.name"
            disabled
          />
          <!-- End:: Company Name -->

          <!-- Start:: Mobile -->
          <base-phone-input
            col="6"
            disabled
            v-model="data.phone"
            :placeholder="$t('SIDENAV.SecurityCompanies.mobile')"
            :defaultCountry="data.iso_code"
          />
          <!-- End:: Mobile -->

          <!-- Start:: Email -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.SecurityCompanies.email')"
            v-model.trim="data.email"
            disabled
          />
          <!-- End:: Email -->

          <!-- Start:: Commercial Registration Number -->
          <base-input
            col="6"
            type="text"
            :placeholder="
              $t('SIDENAV.SecurityCompanies.commercialRegistrationNumber')
            "
            v-model.trim="data.commercial_registration_number"
            disabled
          />
          <!-- End:: Commercial Registration Number -->

          <!-- Start:: Created Date -->
          <base-input
            col="6"
            type="text"
            :placeholder="$t('SIDENAV.SecurityCompanies.registrationDate')"
            v-model.trim="data.created_at"
            disabled
          />
          <!-- End:: Created Date -->

          <!-- Start:: Documents Section -->
          <div class="col-12 mt-4 mb-3">
            <h5
              style="
                color: #26a1d6;
                border-bottom: 2px solid #26a1d6;
                padding-bottom: 10px;
              "
            >
              {{ $t("SIDENAV.SecurityCompanies.documents") }}
            </h5>
          </div>

          <!-- Start:: Commercial Registration Image -->
          <div class="col-12 mb-4">
            <h6 style="color: #26a1d6; margin-bottom: 15px">
              {{ $t("SIDENAV.SecurityCompanies.commercialRegistrationImage") }}
            </h6>
            <div class="preview-container text-center">
              <img
                v-if="data.commercial_registration_image.path"
                :src="data.commercial_registration_image.path"
                :alt="
                  $t('SIDENAV.SecurityCompanies.commercialRegistrationImage')
                "
                style="
                  max-width: 100%;
                  max-height: 400px;
                  border-radius: 8px;
                  border: 1px solid #ddd;
                  cursor: pointer;
                "
                @click="openImageModal(data.commercial_registration_image.path)"
              />
              <p v-else class="text-muted">
                {{ $t("SIDENAV.SecurityCompanies.noImageAvailable") }}
              </p>
            </div>
          </div>
          <!-- End:: Commercial Registration Image -->
        </div>
      </form>
      <!-- ==== End:: Security Company Data ==== -->
    </div>
    <!-- End:: Single Step Form Content -->
  </div>
</template>

<script>
import BasePhoneInput from "@/components/formInputs/BasePhoneInput.vue";
export default {
  name: "SingleClient",
  components: {
    BasePhoneInput,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      // Start:: Loading Data
      isWaitingRequest: false,
      // End:: Loading Data

      // Start:: Data
      data: {
        id: null,
        name: null,
        phone: null,
        email: null,
        commercial_registration_number: null,
        commercial_registration_image: {
          path: null,
          file: null,
        },
        iso_code: null,
        dial_code: null,
        created_at: null,
        active: false,
      },
      // End:: Data
    };
  },

  methods: {
    // Start:: Get Data To Show
    async getDataToShow() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `providers/${this.$route.params.id}`,
        });
        const company = res.data.data?.data || res.data.data;

        this.data.id = company.id;
        this.data.name = company.name;
        this.data.phone = company.mobile;
        this.data.dial_code = company.dial_code;
        this.data.iso_code = company.code;
        this.data.email = company.email;
        this.data.commercial_registration_number =
          company.commercial_registration_number;
        this.data.commercial_registration_image.path =
          company.commercial_registration_image;
        this.data.created_at = company.created_at;
        this.data.active = company.is_active;
      } catch (error) {
        console.log(error.response?.data?.message || error.message);
      }
    },

    // Start:: Open Image Modal
    openImageModal(imageUrl) {
      if (imageUrl) {
        window.open(imageUrl, "_blank");
      }
    },
    // End:: Open Image Modal
  },

  created() {
    // Start:: Fire Methods
    this.getDataToShow();
    // End:: Fire Methods
  },
};
</script>
<style>
.preview-container img {
  max-width: 100%;
  max-height: 200px;
  border: 1px solid #ccc;
  border-radius: 15px;
}
</style>
